import { 
  AppBar, 
  Dialog,
  IconButton, 
  makeStyles,
  Toolbar,
  Typography
} from "@material-ui/core";

import CloseIcon from '@material-ui/icons/Close';
import { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

export const ViewPDFComponent = ({data, open, handleClose}) => {
  /**
   * States here
   */
  const classes = useStyles();

  /**
   * Methods here
   */

  /**
   * UseEffect here
   */
  useEffect(() => {

  }, []);
  return (
    <div>
      <Dialog fullScreen open={open} onClose={handleClose} >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              {data?.id}
            </Typography>
            <IconButton color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div style={{display: "flex", alignContent: "center", justifyContent: "center", marginTop: "30px"}}>
          <object type="application/pdf" width={"80%"} height={"980px"} data={data?.url} ></object>
        </div>
      </Dialog>
    </div>
  );
};